<style lang="sass" scoped>
.py_form_item_box
  position: relative
  padding-bottom: 20px

  .i-form-item-message
    position: absolute
    bottom: 0
</style>

<template>
  <div>
    <!-- <label v-if="label" :class="{ 'i-form-item-label-required': isRequired }">{{ label }}</label> -->
    <div :class="[{'error_form': validateState === 'error'}, 'py_form_item_box']">
      <slot></slot>
      <div v-if="validateState === 'error'" class="i-form-item-message">{{ validateMessage }}</div>
    </div>
  </div>
</template>
<script>
import AsyncValidator from 'async-validator'
import Emitter from 'utils/emitters'

export default {
  name: 'PyFormItem',
  mixins: [Emitter],
  inject: ['form'],
  provide() {
    return {
      itemPass: this.passItem
    }
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    prop: {
      type: String,
    },
  },
  data() {
    return {
      passItem: {
        pass: true
      },
      isRequired: false, // Required or not   // 是否为必填状态
      validateState: '', // Verify status   // 校验的状态
      validateMessage: '', // Prompt message when verification fails   // 校验不通过时的提示信息
    }
  },
  computed: {
    // Get the data of the current form component dynamically from the Form model
    // 从 'Form' 的 'model' 中动态得到当前表单组件的数据
    fieldValue() {
      return this.form.model[this.prop]
    },
  },
  methods: {
    setRules() {
      const rules = this.getRules()
      if (rules.length) {
        rules.every(rule => {
          // If there is a required item in the current verification rule, mark it
          // 如果当前校验规则中有必填项，则标记出来
          this.isRequired = rule.required
        })
      }

      this.$on('on-form-blur', this.onFieldBlur)
      this.$on('on-form-change', this.onFieldChange)
    },
    // Get the verification rules of the current FormItem from the rules attribute of the Form
    // 从 'Form' 的 'rules' 属性中，获取当前 'FormItem' 的校验规则
    getRules() {
      let formRules = this.form.rules

      formRules = formRules ? formRules[this.prop] : []

      return [].concat(formRules || [])
    },
    // Only blur and change are supported, so qualified rule rules are filtered out
    // 只支持 'blur' 和 'change'，所以过滤出符合要求的 rule
    getFilteredRule(trigger) {
      // If an empty string is passed, an array of all rule numbers is returned
      // 如果传递为空字符串，则返回全部 rule 数组
      const rules = this.getRules()
      return rules.filter(
        rule => !rule.trigger || rule.trigger.indexOf(trigger) !== -1,
      )
    },

    /**
     * Check data
     * @param trigger parity bit
     * @param callback Callback function
     */
    /**
     * 校验数据
     * @param trigger 校验的类型
     * @param callback 回调的函数
     */
    validate(trigger, callback = function() {}) {
      const rules = this.getFilteredRule(trigger)
      if (!rules || rules.length === 0) {
        return true
      }

      // Set the status to Verifying
      // 设置状态为 '校验中'
      this.validateState = 'validating'

      // The following is the calling method of the async validator library
      // 以下为 'async-validator 库' 的调用方法
      const descriptor = {}
      descriptor[this.prop] = rules

      const validator = new AsyncValidator(descriptor)
      const model = {}

      model[this.prop] = this.fieldValue

      validator.validate(model, { firstFields: true }, errors => {
        this.validateState = !errors ? 'success' : 'error'
        this.validateMessage = errors ? errors[0].message : ''

        if (this.validateMessage.length > 0) {
          console.log('Error Message:' + this.validateMessage)
        }

        if (errors) {
          this.passItem.pass = false
        } else {
          this.passItem.pass = true
        }
        callback(this.validateMessage)
      })
    },

    // Clear Validation Results
    // 清除验证的结果
    _clearValidate() {
      this.validateState = ''
      this.validateMessage = ''
      this.passItem.pass = true
    },

    // Reset Data
    // 重置数据
    resetField() {
      this.validateState = ''
      this.validateMessage = ''
      this.passItem.pass = true
      this.form.model[this.prop] = this.initialValue
    },

    onFieldBlur() {
      this.validate('blur', this.handleBlurCallBack)
    },

    handleBlurCallBack(errorMsg) {
      console.log(errorMsg)
      if (errorMsg) {
        this.passItem.pass = false
      } else {
        this.passItem.pass = true
      }
    },

    onFieldChange() {
      this.validate('change', this.handleChangeCallBack)
    },

    handleChangeCallBack(errorMsg) {
      console.log(errorMsg)
      if (errorMsg) {
        this.passItem.pass = false
      } else {
        this.passItem.pass = true
      }
    },
  },

  // When components render, cache instances in the Form
  // 组件渲染时，将实例缓存在 'Form' 中
  mounted() {
    // If an empty string is passed, an array of all rule numbers is returned
    // 如果传递为空字符串，返回全部 'rule' 数组
    // const res = this.getFilteredRule('')
    // console.log(res)

    // If no prop is passed in, there is no need for verification and caching
    // 如果没有传入 'prop'，则无需校验，也无需缓存
    if (this.prop) {
      this.dispatch('PyForm', 'on-form-item-add', this)

      // Set the initial value to restore the default value when resetting
      // 设置初始值，以便在重置时恢复默认值
      this.initialValue = this.fieldValue

      this.setRules()
    }
  },

  // Remove the instance from the form cache before destroying the component
  // 在组件销毁前，将实例从 'Form' 的缓存中移除
  beforeDestroy() {
    this.dispatch('PyForm', 'on-form-item-remove', this)
  },
}
</script>

<style>
.i-form-item-label-required:before {
  content: '*';
  color: red;
}

.i-form-item-message {
  color: red;
  white-space: nowrap
}
</style>
